import api from "@/lib/api";

function hHeader() {
  const hid = typeof document !== "undefined" ? document.cookie
    .split(";").map(c => c.trim()).find(c => c.startsWith("active_hotel_id=")) : null;
  const val = hid ? decodeURIComponent(hid.split("=")[1]) : null;
  return val ? { "X-Hocp-Hotel": val } : {};
}
const H = () => ({ headers: hHeader() });

export const finAPI = {
  // Dashboard + Business Date
  dashboard:      ()                       => api.get("/fin/v1/dashboard", H()).then(r => r.data),
  businessDate:   ()                       => api.get("/fin/v1/business-date", H()).then(r => r.data),

  // Payments
  payments:       (params = {})            => api.get("/fin/v1/payments", { ...H(), params }).then(r => r.data),
  createPayment:  (body)                   => api.post("/fin/v1/payments", body, H()).then(r => r.data),
  voidPayment:    (id, body)               => api.post(`/fin/v1/payments/${id}/void`, body, H()).then(r => r.data),

  // Refunds
  refunds:        (params = {})            => api.get("/fin/v1/refunds", { ...H(), params }).then(r => r.data),
  createRefund:   (body)                   => api.post("/fin/v1/refunds", body, H()).then(r => r.data),
  approveRefund:  (id, body)               => api.post(`/fin/v1/refunds/${id}/approve`, body, H()).then(r => r.data),
  rejectRefund:   (id, body)               => api.post(`/fin/v1/refunds/${id}/reject`, body, H()).then(r => r.data),
  processRefund:  (id, body)               => api.post(`/fin/v1/refunds/${id}/process`, body, H()).then(r => r.data),

  // Discounts
  discounts:      (params = {})            => api.get("/fin/v1/discounts", { ...H(), params }).then(r => r.data),
  createDiscount: (body)                   => api.post("/fin/v1/discounts", body, H()).then(r => r.data),
  approveDiscount:(id, body)               => api.post(`/fin/v1/discounts/${id}/approve`, body, H()).then(r => r.data),
  rejectDiscount: (id, body)               => api.post(`/fin/v1/discounts/${id}/reject`, body, H()).then(r => r.data),

  // Complimentary
  comps:          (params = {})            => api.get("/fin/v1/comps", { ...H(), params }).then(r => r.data),
  createComp:     (body)                   => api.post("/fin/v1/comps", body, H()).then(r => r.data),
  approveComp:    (id, body)               => api.post(`/fin/v1/comps/${id}/approve`, body, H()).then(r => r.data),

  // Cash shifts
  shifts:         (params = {})            => api.get("/fin/v1/shifts", { ...H(), params }).then(r => r.data),
  openShift:      (body)                   => api.post("/fin/v1/shifts/open", body, H()).then(r => r.data),
  addShiftTxn:    (id, body)               => api.post(`/fin/v1/shifts/${id}/txn`, body, H()).then(r => r.data),
  closeShift:     (id, body)               => api.post(`/fin/v1/shifts/${id}/close`, body, H()).then(r => r.data),

  // Revenue Audit
  flags:          (params = {})            => api.get("/fin/v1/flags", { ...H(), params }).then(r => r.data),
  scan:           (params = {})            => api.post("/fin/v1/audit/scan", null, { ...H(), params }).then(r => r.data),
  resolveFlag:    (id, body)               => api.post(`/fin/v1/flags/${id}/resolve`, body, H()).then(r => r.data),

  // Night Audit
  nightAudits:    (params = {})            => api.get("/fin/v1/night-audits", { ...H(), params }).then(r => r.data),
  runNightAudit:  (body)                   => api.post("/fin/v1/night-audit/run", body, H()).then(r => r.data),
  nightAuditStale: ()                      => api.get("/fin/v1/night-audit/stale", H()).then(r => r.data),
  postRoomNights: (body)                   => api.post("/fin/v1/room-nights/post", body, H()).then(r => r.data),

  // Event Ledger
  events:         (params = {})            => api.get("/fin/v1/events", { ...H(), params }).then(r => r.data),
  eventKinds:     ()                       => api.get("/fin/v1/events/kinds", H()).then(r => r.data),
};

// ── formatting helpers (decimal-safe) ────────────────────────────────────
export const fmtINR = (n) => {
  const v = Number(n || 0);
  if (!isFinite(v)) return "₹0";
  return "₹" + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fmtINRshort = (n) => {
  const v = Number(n || 0);
  if (v >= 1e7) return "₹" + (v/1e7).toFixed(2) + "Cr";
  if (v >= 1e5) return "₹" + (v/1e5).toFixed(2) + "L";
  if (v >= 1e3) return "₹" + (v/1e3).toFixed(1) + "k";
  return "₹" + v.toFixed(0);
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

// ── Status styling ────────────────────────────────────────────────────────
export const STATUS_STYLE = {
  received:  { chip: "bg-emerald-100 text-emerald-700",  label: "Received" },
  voided:    { chip: "bg-rose-100 text-rose-700",        label: "Voided" },
  requested: { chip: "bg-amber-100 text-amber-700",      label: "Pending" },
  approved:  { chip: "bg-sky-100 text-sky-700",          label: "Approved" },
  rejected:  { chip: "bg-rose-100 text-rose-700",        label: "Rejected" },
  processed: { chip: "bg-emerald-100 text-emerald-700",  label: "Processed" },
  open:      { chip: "bg-sky-100 text-sky-700",          label: "Open" },
  closed:    { chip: "bg-slate-100 text-slate-600",      label: "Closed" },
  resolved:  { chip: "bg-emerald-100 text-emerald-700",  label: "Resolved" },
  completed: { chip: "bg-emerald-100 text-emerald-700",  label: "Completed" },
};

export const METHOD_STYLE = {
  cash:           { chip: "bg-emerald-100 text-emerald-700", label: "Cash" },
  card:           { chip: "bg-sky-100 text-sky-700",         label: "Card" },
  upi:            { chip: "bg-violet-100 text-violet-700",   label: "UPI" },
  bank_transfer:  { chip: "bg-slate-100 text-slate-700",     label: "Bank" },
  corporate:      { chip: "bg-amber-100 text-amber-700",     label: "Corporate" },
  online:         { chip: "bg-cyan-100 text-cyan-700",       label: "Online" },
  wallet:         { chip: "bg-fuchsia-100 text-fuchsia-700", label: "Wallet" },
};

export const SEVERITY_STYLE = {
  low:      { chip: "bg-slate-100 text-slate-700",     dot: "bg-slate-400"  },
  medium:   { chip: "bg-amber-100 text-amber-800",     dot: "bg-amber-500"  },
  high:     { chip: "bg-rose-100 text-rose-800",       dot: "bg-rose-500"   },
  critical: { chip: "bg-rose-500/20 text-rose-800",    dot: "bg-rose-600"   },
};
